// extracted by mini-css-extract-plugin
export default {"main":"EditRoleGroup_main__qtpJe","role_group":"EditRoleGroup_role_group__GHKEK","save":"EditRoleGroup_save__jSa72"};